const dashboard_layout = {
    dashboardItemName: String("Tauler principal"),
    terrainsItemName: String("Finques"),
    plotsItemName: String("Parcel·les"),
    modulesItemName: String("Estacions"),
    accountItemName: String("El meu perfil"),
    graphicsItemName: String("Gràfics"),
    userOverlayBoxTitle: String("Benvingut {name}"),
    profile: String("El meu perfil"),
    logOut: String("Tancar sessió"),
    footerAboutUs: String("Sobre nosaltres"),
    footerContactUs: String("Poseu-vos en contacte amb nosaltres"),
};

export default dashboard_layout;